export const GOAL_OPTIONS = [
  { value: 'ege', label: 'ЕГЭ' },
  { value: 'oge', label: 'ОГЭ' },
  { value: 'oge_ege', label: 'ОГЭ + ЕГЭ' },
  { value: 'other', label: 'Другое' },
];

export const EGE_YEAR_OPTIONS = [
  { value: '2027', label: '2027' },
  { value: '2028', label: '2028' },
  { value: 'other', label: 'Другое' },
];

export const SCORE_OPTIONS = [
  { value: '100', label: '100' },
  { value: '90plus', label: '90+' },
  { value: '80plus', label: '80+' },
  { value: '70plus', label: '70+' },
  { value: 'threshold', label: 'Пройти порог' },
];

export const HOMEWORK_OPTIONS = [
  { value: 'always_careful', label: 'Всегда делаю старательно' },
  { value: 'try_fully', label: 'Стараюсь делать полностью' },
  { value: 'hard_to_force', label: 'Сложно себя заставить' },
];

export const WORKLOAD_OPTIONS = [
  { value: 'high', label: 'Высокая (очень мало времени остается)' },
  { value: 'medium', label: 'Средняя' },
  { value: 'low', label: 'Низкая' },
];

export const GROUP_OPTIONS = [
  { value: 'interested', label: 'Интересно' },
  { value: 'can_try', label: 'Можно попробовать' },
  { value: 'need_think', label: 'Может быть, надо подумать' },
  { value: 'no', label: 'Категорически нет, не важно что это за группы' },
];

export const FINANCE_OPTIONS = [
  { value: 'max_efficiency', label: 'Выбираем по максимальной эффективности' },
  { value: 'balance', label: 'Разумный баланс цена / качество' },
  { value: 'cheaper', label: 'Хотелось бы подешевле, но без потери баллов' },
  { value: 'consultations', label: 'Есть возможность оплачивать эпизодические консультации, не более' },
  { value: 'none', label: 'Нет возможности оплачивать совсем' },
];

export const EMPTY_QUESTIONNAIRE = {
  goal: '',
  goal_other: '',
  ege_year: '',
  ege_year_other: '',
  target_score: '',
  homework_attitude: '',
  workload: '',
  group_attitude: '',
  finance: '',
  comment: '',
};

export const GROUP_LESSONS_EXPLANATION =
  'В каждый момент времени я общаюсь только с одним учеником. Ученики общаются всегда только со мной. '
  + 'Исключительно индивидуальный план для каждого ученика, никаких совместных заданий. '
  + 'Переключаться могу за счёт того, что ученику нужно дать время подумать над задачей. '
  + 'На случай, если ученику нужна помощь, а я занят с другим учеником, есть специальные мини-задания для каждого занятия.';

export function needsEgeDetails(goal) {
  return goal === 'ege' || goal === 'oge_ege';
}

export function optionLabel(options, value) {
  if (!value) return '—';
  const found = options.find((o) => o.value === value);
  return found ? found.label : value;
}

export function questionnaireFromApi(data) {
  if (!data || data.filled === false) {
    return { ...EMPTY_QUESTIONNAIRE };
  }
  const next = { ...EMPTY_QUESTIONNAIRE };
  Object.keys(EMPTY_QUESTIONNAIRE).forEach((key) => {
    next[key] = data[key] ?? '';
  });
  return next;
}
